window.BIP = window.BIP || {};

window.BIP.formatMoney = function (cents) {
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency });
};

window.BIP.updateCartCount = function (count) {
  var countEl = document.querySelector('[data-cart-count]');
  if (countEl) {
    if (count === 0) {
      countEl.textContent = '';
    } else if (count === 1) {
      countEl.textContent = ' (1 item)';
    } else {
      countEl.textContent = ' (' + count + ' items)';
    }
  }

  var badge = document.querySelector('[data-cart-badge]');
  if (badge) {
    badge.textContent = count;
    badge.hidden = count === 0;
  }
};
